// @flow

import BaseService from 'app-my-account/services/base-service';

export class AccidentService extends BaseService {
	API_BASE_URL_PARTS = ['lk', 'profiles', 'my', 'accident'];
}
